import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent  {
  title = 'sustainible-frontend';
  // route$: Observable<any>;
  // routesWhereNavigationHidden: string[] = ['/register-user', '/sign-in', '/onboard'];
  // ngOnInit() {
  //   this.route$ = this.route.events
  //   .pipe(filter(event => event instanceof NavigationEnd));
  // }
}
